<template>
  <div class="log-message" :title="content">
    {{ content }}
  </div>
</template>

<script>
export default {
  name: 'MessageCell',
  // Props are dictated by @kingscode/vuetify-resource columnType API
  props: {
    content: { type: [String, Number], default: '' },
  },
};
</script>

<style scoped>
.log-message {
  width: 1000px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
